import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { QBOEnvironment } from 'src/environments/environment';
import { CommonPagesService } from '../../common-pages.service';
import { ResponseStatus } from '../../enum';

@Component({
  selector: 'app-add-update-credit',
  templateUrl: './add-update-credit.component.html',
  styleUrls: ['./add-update-credit.component.scss'],

  standalone: false,
})
export class AddUpdateCreditComponent {
  isVisibleCreditModal: any = true;
  isLoadingPrograms: any = false;
  isLoadingCredit: any = false;
  isLoadingTags: any = false;
  isCreditSkeleton: any = false;
  listOfProgramPeriods: any;
  qboOriginalbillLink: any = null;
  getCreditDetail: any;
  selectedTag: any;
  @Output() hideCreditDrawer = new EventEmitter();
  @Input() selectedData: any;
  selectedTagGroup: any = '';
  isResyncingData: boolean = false;
  listOfTags: any[] = [];
  listOfUnfilteredTags: any[] = [];
  refNo: any = 0;
  qboURL = QBOEnvironment.URL;

  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService
  ) {
    _fS.expenseForm_fb();
  }
  ngOnInit(): void {
    this.getCreditDetails();
    // this.loadPrograms('');
  }

  handleCancel(data: any) {
    this.isVisibleCreditModal = false;
    this.hideCreditDrawer.emit({
      hide: this.isVisibleCreditModal,
      data: data,
    });
  }
  resynCreditData() {
    this.isResyncingData = true;
    this._cpS
      .resyncCreditData(this.selectedData.id)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          if (response.result.isCreditDeleted) {
            this._cS.displayMessage(
              'warning',
              'This transaction is deleted from QBO'
            );
            this.isResyncingData = false;
            this.handleCancel(response.result);
          } else {
            this.isResyncingData = false;
            this.getCreditDetail = response.result;
            this._cS.displayMessage('success', response.message);
          }
        } else {
          this.isResyncingData = false;
          this._cS.displayMessage('error', response.message);
        }
      });
  }
  getCreditDetails() {
    this.isCreditSkeleton = true;
    this._cpS
      .GetCreditDetail(this.selectedData.id)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.getCreditDetail = response.result;

          this._fS.expenseForm.patchValue({
            programPeriod: this.getCreditDetail?.program?.id,
            tags: this.getCreditDetail?.tag?.id,
            isNonAlc: this.getCreditDetail?.isNonAlc,
          });
          this.refNo = this.getCreditDetail.referenceNo;
          this.getTags();
          this.loadPrograms();
          this.getSiteDetails();
          this.isCreditSkeleton = false;
        }
      });
  }
  siteDetails: any;
  getSiteDetails() {
    this._cpS
      .GetSiteDetails(this.getCreditDetail.siteId)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.siteDetails = response.result;
        }
      });
  }
  searchTagGroupAndTags(searchTerm) {
    // Make the search term case insensitive
    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    const result = this.listOfTags
      .map((item) => {
        // Check if the event's Name matches the search term
        const isNameMatch =
          item.Name.toLowerCase().includes(lowerCaseSearchTerm);

        // Filter the tags that match the search term
        const matchingTags = item.Tags.filter((tag) =>
          tag.Name.toLowerCase().includes(lowerCaseSearchTerm)
        );

        // If the event name matches, include the whole item with all tags
        if (isNameMatch) {
          return {
            ...item,
            Tags: item.Tags,
          };
        }

        // If there are matching tags, include the item with only those tags
        if (matchingTags.length > 0) {
          return {
            ...item,
            Tags: matchingTags,
          };
        }

        // Otherwise, exclude this item
        return null;
      })
      .filter((item) => item !== null);

    // Output the result
    return result;
  }
  returnFilteredTags(searchTerm) {
    if (searchTerm) {

      const filteredResult = this.searchTagGroupAndTags(searchTerm);
      this.listOfTags = filteredResult;
    } else {
      this.listOfTags = this.listOfUnfilteredTags;
    }
  }

  loadPrograms() {
    this.isLoadingPrograms = true;
    this._cpS
      .getProgramBySite(this.getCreditDetail.siteId)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isLoadingPrograms = false;
          this.listOfProgramPeriods = response.result;
          var defaultProgram = this.listOfProgramPeriods.find(
            (x: any) => x?.isDefault
          );
          if (this.selectedData == null) {
            this._fS.expenseForm.patchValue({
              programPeriod: defaultProgram?.id,
            });
          }
        } else {
          this.listOfProgramPeriods = [];
          this.isLoadingPrograms = false;
          this._cS.displayMessage('error', response.message);
        }
      });
  }

  getTags() {
    this.isLoadingTags = true;
    this._cpS.getTagsDropdownList(this.getCreditDetail.siteId).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.listOfTags = response.result;
          this.listOfUnfilteredTags = JSON.parse(
            JSON.stringify(response.result)
          )

          this.checkTagGroupData(this.getCreditDetail?.tag?.id);
          this.isLoadingTags = false;
        } else {
          this.isLoadingTags = false;
          this._cS.displayMessage('error', response.message);
          this.listOfTags = [];
        }
      },
      (error: any) => {
        this.isLoadingTags = false;
        this.listOfTags = [];
      }
    );
  }

  checkTagGroupData(event: any) {
    var selectedGroup: any;
    var selectedTag: any;
    this.listOfTags.forEach((element: any) => {
      element.Tags.forEach((tag: any) => {
        if (tag._id == event) {
          selectedTag = tag;
          selectedGroup = element;
        }
      });
    });
    this.selectedTagGroup = selectedGroup;
    this.selectedTag = selectedTag?.Name;
  }

  updateCredit() {
    if (this._fS.expenseForm.valid) {
      this.isLoadingCredit = true;
      var formValueCredit = this._fS.expenseForm.value;

      var selectedProgram = this.listOfProgramPeriods.find(
        (x: any) => x.id == formValueCredit.programPeriod
      );
      var expenseData = {
        id: this.selectedData.id,
        program: {
          id: formValueCredit.programPeriod,
          name: selectedProgram.label,
        },
        tag: {
          id: formValueCredit.tags,
          name: this.selectedTag,
        },
        isNonAlc: formValueCredit.isNonAlc,
      };
      this._cpS.updateCredit(expenseData).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);
          //hide credit drawer
          this.isVisibleCreditModal = false;
          this.hideCreditDrawer.emit({
            hide: this.isVisibleCreditModal,
            data: null,
          });
          this.isLoadingCredit = false;
        } else {
          this._cS.displayMessage('error', response.message);
          this.isLoadingCredit = false;
        }
      });
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.expenseForm);
    }
  }
}
